import styled from 'styled-components'
import { darken } from 'polished'

interface IButtonProps {
  buttonSize?: string
  buttonType?: string
  desabilitado?: boolean
}

function converteTamanho(tamanho: string | undefined) {
  if (tamanho === 'large') {
    return '56px'
  }
  if (tamanho === 'small') {
    return '30px'
  } else {
    return '40px'
  }
}
function converteCorFundo(corEscolhida: string | undefined) {
  if (corEscolhida === 'secondary') {
    return 'var(--white)'
  }
  if (corEscolhida === 'warning') {
    return 'var(--yellow-300)'
  } else {
    return 'linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), var(--blue-600)'
  }
}
function converteCorEscrita(corEscolhida: string | undefined) {
  if (corEscolhida === 'secondary') {
    return 'var(--blue-600)'
  }
  if (corEscolhida === 'warning') {
    return 'var(--black)'
  } else {
    return 'var(--white)'
  }
}

export const Botao = styled.button<IButtonProps>`
  transition: background-color 0.2s;
  width: 100%;
  height: ${({ buttonSize }) => converteTamanho(buttonSize)};
  padding: 12px 16px 12px 16px;
  background: ${({ buttonType }) => converteCorFundo(buttonType)};
  ${(props) => (props.desabilitado ? 'background-color: var(--grey-600)' : '')}
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  ${(props) => (props.desabilitado ? 'cursor: auto;' : '')}
  user-select: none;
  border-radius: 5px;
  border: ${({ buttonType }) =>
    buttonType === 'secondary' ? 'solid 2px var(--blue-600)' : 'none'};

  &:hover {
    ${(props) => {
      switch (props.buttonType) {
        case 'primary':
          return `background-color: ${darken(0.1, '#3761AB')} ;`
        case 'secondary':
          return `background-color: ${darken(0.1, '#FFFFFF')} ;`
        case 'warning':
          return `background-color: ${darken(0.1, '#FFAE11')} ;`
      }
    }}
  }
`

export const Span = styled.span<IButtonProps>`
  margin: ${({ buttonType }) =>
    buttonType === 'warning' ? '0px 8px' : '0px 12px;'};
  font-size: ${({ buttonType }) =>
    buttonType === 'warning' ? '20px' : '16px'};
  font-weight: 700;
  color: ${({ buttonType }) => converteCorEscrita(buttonType)};
`
